import Info from '@/components/ui/info/info';
export default Info;
